import { Component } from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';

export default class Button extends Component {
  static propTypes = {
    ariaLabel: PropTypes.string,
    backgroundColor: PropTypes.string,
    border: PropTypes.string,
    className: PropTypes.string,
    dataTestId: PropTypes.string,
    disabled: PropTypes.bool,
    fullWidth: PropTypes.bool,
    href: PropTypes.string,
    icon: PropTypes.string,
    iconClassName: PropTypes.string,
    iconLeftAligned: PropTypes.bool,
    isSubmit: PropTypes.bool,
    onClick: PropTypes.func,
    onMouseEnter: PropTypes.func,
    onMouseLeave: PropTypes.func,
    role: PropTypes.string,
    size: PropTypes.oneOf(['sm', 'lg', 'lg-wide']),
    tabIndex: PropTypes.string,
    text: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    transitional: PropTypes.bool,
    type: PropTypes.oneOf(['primary', 'secondary', 'tertiary', 'google', 'facebook', 'none', 'blank', 'link']),
  };

  static defaultProps = {
    ariaLabel: null,
    backgroundColor: null,
    border: null,
    className: '',
    dataTestId: null,
    disabled: false,
    fullWidth: false,
    iconLeftAligned: true,
    isSubmit: false,
    role: '',
    tabIndex: '',
    text: '',
    transitional: false,
    type: 'primary',
    onClick: () => {},
    onMouseEnter: () => {},
    onMouseLeave: () => {},
  };

  onClick = e => {
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'onClick' does not exist on type 'Readonl... Remove this comment to see the full error message
    this.props.onClick(e);
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'href' does not exist on type 'Readonly<{... Remove this comment to see the full error message
    if (this.props.href) {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'href' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      window.location.href = this.props.href;
    }
  };

  render() {
    const {
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'ariaLabel' does not exist on type 'Reado... Remove this comment to see the full error message
      ariaLabel,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'border' does not exist on type 'Readonly... Remove this comment to see the full error message
      border,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'backgroundColor' does not exist on type ... Remove this comment to see the full error message
      backgroundColor,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'className' does not exist on type 'Reado... Remove this comment to see the full error message
      className,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'dataTestId' does not exist on type 'Read... Remove this comment to see the full error message
      dataTestId,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'disabled' does not exist on type 'Readon... Remove this comment to see the full error message
      disabled,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'fullWidth' does not exist on type 'Reado... Remove this comment to see the full error message
      fullWidth,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'icon' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      icon,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type 'Readonly<{}>... Remove this comment to see the full error message
      id,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'iconLeftAligned' does not exist on type ... Remove this comment to see the full error message
      iconLeftAligned,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'isSubmit' does not exist on type 'Readon... Remove this comment to see the full error message
      isSubmit,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'iconClassName' does not exist on type 'R... Remove this comment to see the full error message
      iconClassName,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'role' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      role,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'size' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      size,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'text' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      text,
      children,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'tabIndex' does not exist on type 'Readon... Remove this comment to see the full error message
      tabIndex,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'transitional' does not exist on type 'Re... Remove this comment to see the full error message
      transitional,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'type' does not exist on type 'Readonly<{... Remove this comment to see the full error message
      type,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onMouseEnter' does not exist on type 'Re... Remove this comment to see the full error message
      onMouseEnter,
      // @ts-expect-error ts-migrate(2339) FIXME: Property 'onMouseLeave' does not exist on type 'Re... Remove this comment to see the full error message
      onMouseLeave,
    } = this.props;

    const classes = classNames({
      'btn--full-width': fullWidth,
      'btn--transitional': transitional,
      btn: true,
      [`btn-${type}`]: !!type,
      [`btn-${size}`]: !!size,
      [className]: className,
    });

    const iconClasses = classNames({
      icon: true,
      [`icon-${icon}`]: true,
      [iconClassName]: !!iconClassName,
    });

    const styles = {
      border,
      backgroundColor,
    };

    const buttonText = text || children;

    const extraProps = {};
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'id' does not exist on type '{}'.
    if (id) extraProps.id = id;
    if (dataTestId) extraProps['data-test-id'] = dataTestId;
    // Accessibility
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'tabIndex' does not exist on type '{}'.
    if (tabIndex) extraProps.tabIndex = tabIndex;
    // @ts-expect-error ts-migrate(2339) FIXME: Property 'role' does not exist on type '{}'.
    if (role) extraProps.role = role;

    return (
      <button
        aria-label={ariaLabel}
        className={classes}
        disabled={disabled}
        style={styles}
        type={isSubmit ? 'submit' : 'button'}
        onClick={this.onClick}
        onMouseEnter={onMouseEnter}
        onMouseLeave={onMouseLeave}
        {...extraProps}
      >
        {icon && iconLeftAligned && <span className={iconClasses} />}
        {icon && iconLeftAligned && ' '}
        {buttonText}
        {transitional && <span className="icon icon-right-open" />}
        {icon && !iconLeftAligned && ' '}
        {icon && !iconLeftAligned && <span className={iconClasses} />}
      </button>
    );
  }
}
